var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useMemo, useRef, useState } from "react";
import { nanoid } from "nanoid";
// icons
import Edelicon from "@frameworks/shared-library/components/Generic/Edelicon";
// css
import "@frameworks/shared-library/stylesheets/components/SearchPanelWithPopupFiltersLabel/SearchPanelWithPopupFiltersLabel.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
// components
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import FundSearchPanel from "@frameworks/shared-library/components/Generic/FundSeachPanel/FundSearchPanel";
import GenericPopup from "@frameworks/shared-library/components/GenericPopup";
import GenericTabs from "@frameworks/shared-library/components/GenericTabs";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import FilterLabels from "@frameworks/shared-library/components/FilterLabels/FilterLabels";
var SearchPanelWithPopupFiltersLabel = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var _h = _a.showFilter, showFilter = _h === void 0 ? true : _h, props = __rest(_a, ["showFilter"]);
    var _j = props.iconClassName, iconClassName = _j === void 0 ? "edel-icon-filter-1 fs-39" : _j, _k = props.isOrderBook, isOrderBook = _k === void 0 ? false : _k;
    var device = DeviceContext();
    var uniqueIdForPop = nanoid();
    var _l = __read(useState(false), 2), isShowHiddenFilters = _l[0], setIsShowHiddenFilters = _l[1];
    var _m = __read(useState(0), 2), countOfHiddenFilters = _m[0], setCountOfHiddenFilters = _m[1];
    var selectedLabelsContainerRef = useRef(null);
    var SelectedFilters = React.useMemo(function () { return function (filterObj) {
        return (React.createElement(FilterLabels, { customLabel: filterObj.title, closeBtn: !filterObj.disable, value: filterObj.value, key: "".concat(filterObj.value, "-").concat(filterObj.subKeyName), FilterAction: function () {
                props.removeFilterThroughLabels(filterObj === null || filterObj === void 0 ? void 0 : filterObj.typeOfFilter, filterObj.value);
            }, customCloseBtn: "edel-icon-cross-bold-small" }));
    }; }, [props === null || props === void 0 ? void 0 : props.filterLabels]);
    var handleCheckForExtraFilters = function () {
        var container = selectedLabelsContainerRef === null || selectedLabelsContainerRef === void 0 ? void 0 : selectedLabelsContainerRef.current;
        var children = container === null || container === void 0 ? void 0 : container.children;
        var countSecondLine = 0;
        if (!!children && children.length) {
            var firstLineY = null;
            for (var i = 0; i < (children === null || children === void 0 ? void 0 : children.length); i++) {
                var label = children[i];
                var top_1 = label.getBoundingClientRect().top;
                if (firstLineY === null) {
                    firstLineY = top_1;
                }
                if (top_1 !== firstLineY) {
                    countSecondLine++;
                }
            }
        }
        if (countSecondLine === 0) {
            setIsShowHiddenFilters(false);
        }
        setCountOfHiddenFilters(countSecondLine);
    };
    React.useEffect(function () {
        handleCheckForExtraFilters();
    }, [props === null || props === void 0 ? void 0 : props.filterLabels]);
    var filterWithoutAll = useMemo(function () {
        return props.filterLabels.filter(function (item) { return item.title !== "all"; });
    }, [props.filterLabels]);
    return (React.createElement("div", { className: "primary-search-panel-with-popup-filter-labels-container custom-filter  ".concat((_b = props.parentClassName) !== null && _b !== void 0 ? _b : "", " ").concat((device === null || device === void 0 ? void 0 : device.isDesktop)
            ? "d-flex justify-content-between align-items-center"
            : "d-flex flex-column-reverse") },
        React.createElement(FundSearchPanel, __assign({}, props, { parentClassName: props.searchBarParentClassName, autoComplete: "off" })),
        React.createElement("div", { className: "d-flex align-items-center gap-10" },
            showFilter && (React.createElement("div", { className: "".concat(!!props.filterLabels && filterWithoutAll.length
                    ? "primary-filter-popup-btn-label-wrapper"
                    : "position-relative") },
                React.createElement("div", { className: "filter-popup-btn-label-container ".concat(!!props.filterLabels && filterWithoutAll.length
                        ? "filters-applied d-flex align-items-center justify-content-between ".concat(!isOrderBook ? "py-0" : "", " ")
                        : "", " ").concat(isShowHiddenFilters ? "view-hidden-filters" : "") },
                    !!props.filterLabels && filterWithoutAll.length ? (React.createElement("div", { className: "d-flex justify-content-between w-100 filters-label-wrapper" },
                        React.createElement("div", { ref: selectedLabelsContainerRef, className: "selected-filters-labels-container d-flex  flex-wrap w-100" }, filterWithoutAll.map(function (filterObj) {
                            return React.createElement(SelectedFilters, __assign({}, filterObj, { key: nanoid() }));
                        })),
                        countOfHiddenFilters ? (React.createElement(EdButton, { value: !isShowHiddenFilters
                                ? "+".concat(countOfHiddenFilters, " more")
                                : "View Less", btnTyp: "text-only", className: "text-decoration-underline txt-han-blue DMSansNormal_12_400 text-nowrap align-self-start mgt-5", onClick: function () {
                                setIsShowHiddenFilters(!isShowHiddenFilters);
                            } })) : (React.createElement(React.Fragment, null)))) : (React.createElement(React.Fragment, null)),
                    React.createElement("div", { className: "primary-filters-popup-wrapper align-self-start", id: uniqueIdForPop },
                        React.createElement(GenericPopup, { placement: "bottom-end", isHeadline: true, parentClass: "filters-generic-popup aif-pms-popup ".concat((_c = props.genericPopup) !== null && _c !== void 0 ? _c : ""), isShow: props === null || props === void 0 ? void 0 : props.isShowPopup, 
                            // setIsShow={() =>
                            //   !!props.setIsShowPopup &&
                            //   props.setIsShowPopup(!props?.isShowPopup)
                            // }
                            removeTooltipArrow: true, containerDom: function () { return document.getElementById(uniqueIdForPop); }, button: (props === null || props === void 0 ? void 0 : props.customFilterIcon) ? (props.customFilterIcon) : (React.createElement(EdButton, { value: React.createElement(React.Fragment, null,
                                    !!filterWithoutAll &&
                                        filterWithoutAll.length > 0 ? (React.createElement("span", { className: "filter-applied-red-dot-indicator d-flex" })) : (React.createElement(React.Fragment, null)),
                                    React.createElement(Edelicon, { className: " ".concat(iconClassName, " txt-han-blue ").concat(props.filterLabels.length < 1 &&
                                            "border-gray border-radius-10", " ").concat(!isShowHiddenFilters && (props === null || props === void 0 ? void 0 : props.isShowPopup)
                                            ? "border-active-filter"
                                            : "", " "), paths: 3 })), btnTyp: "text-only", slim: true, onClick: function () {
                                    !!props.setIsShowPopup &&
                                        props.setIsShowPopup(!(props === null || props === void 0 ? void 0 : props.isShowPopup));
                                }, className: "p-0 filter-icon-btn" })), children: React.createElement("div", { className: "position-relative offerings-filters-sort-tabs-primary-container sort-filter" },
                                React.createElement(GenericTabs, { defaultActiveKey: "filter", externalClassName: "offerings-sort-filter-tabs w-100", tabsArray: [
                                        {
                                            title: (React.createElement("div", { className: "position-relative" },
                                                "Filter",
                                                ((_d = props.filterLabels) === null || _d === void 0 ? void 0 : _d.length) > 0 && (React.createElement("span", { className: "filter-applied-red-dot-indicator d-flex" })))),
                                            eventKey: "filter",
                                            tabContent: (_e = props.filterComponentInsidePopup) !== null && _e !== void 0 ? _e : (React.createElement(React.Fragment, null)),
                                        },
                                        {
                                            title: React.createElement("div", null, "Sort"),
                                            eventKey: "sort",
                                            tabContent: (_f = props.sortFilterComponentInsidePopup) !== null && _f !== void 0 ? _f : React.createElement(React.Fragment, null),
                                        },
                                    ], callBackFunction: function () { }, navClass: "filter-icon-btn" }),
                                React.createElement("div", { className: "position-absolute top-0 end-0 me-3", style: { marginTop: "15px" } },
                                    React.createElement(EdButton, { btnTyp: "text-only", className: "txt-han-blue DMSanN_14_400", value: "Clear All", onClick: function () {
                                            !!(props === null || props === void 0 ? void 0 : props.handleClearAllPmsFilters) &&
                                                props.handleClearAllPmsFilters();
                                        } }))) }))))), (_g = props.rightSubComponent) !== null && _g !== void 0 ? _g : React.createElement(React.Fragment, null))));
};
export default SearchPanelWithPopupFiltersLabel;
